import React, { useState, useEffect } from 'react'
import { Grid, Form, Container, Button, GridRow, GridColumn, Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./suggestion.module.scss";
import cx from "classnames";
import { updateSuggestions } from "actions/seek";
import { fetchingSuggestions } from "actions/seek"
import { toast } from "react-toastify";
import _ from "lodash";

export default function Suggestion() {
    
    const dispatch = useDispatch();
    const account = useSelector((state) => state.accounts.account);
    const seekSuggestionQuestions = useSelector((state) => _.get(state, "accounts.seekSuggestionQuestions.suggestions", []))
    
    const suggestionSubscription = useSelector(
        (state) => state.accounts.suggestionSubscription
    );

    const [initialRender, setInitialRender] = useState(true);
    const [suggest, setSuggest] = useState([]);

    useEffect(() => {
        if (account) {
            dispatch(
                fetchingSuggestions({
                    id: account.id
                })
            );

        }
   }, [account]);

    useEffect(() => {
        if (seekSuggestionQuestions) {
            let suggestion = seekSuggestionQuestions;
            setSuggest(suggestion);
     }
    }, [seekSuggestionQuestions]);

    useEffect(() => {
        if (!initialRender && !suggestionSubscription.updating) {
            if (suggestionSubscription.success) {
                toast.success(`${account.name} suggestions updated`);
            } else {
                toast.error(`failed to update ${account.name} suggestions `);
            }
        }
    }, [suggestionSubscription]);
   
    const handleSavebutton = () => {
        const questionValues = _.values(suggest);
        dispatch(
            updateSuggestions({
                questionValues, id: account.id
            })

        );
    }
    
    const handleSuggestionClick = (e, index) => {
        let value = e.target.value;

       setSuggest((suggest) => ({
        ...suggest,
        [index]: value
       }))
        
    };
    setTimeout(() => {
        setInitialRender(false);
      }, [3000]);
    return (
        <Grid>
            <Grid.Row columns={2}>
                <Grid.Column size={7}>
                <Container className={styles.container}>
                <Form className={styles.form}>
                <Grid>
                    <GridRow>
                        <GridColumn>
                            <label className={cx(styles.title)}>Prompt Questions</label>
                        </GridColumn>
                    </GridRow>

                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>1</label>
                            <Form.Field className={cx(styles.fieldName)}>
                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e,0)}
                                    value = {_.size(suggest) > 0 ? suggest[0] : ""}

                                />

                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>2</label>
                            <Form.Field className={cx(styles.fieldName)}>
                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e, 1)}
                                    value= {_.size(suggest) > 0 ? suggest[1] : ""}
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>

                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>3</label>
                            <Form.Field className={cx(styles.fieldName)}>

                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e, 2)}
                                    value= {_.size(suggest) > 0 ? suggest[2] : ""}
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>4</label>
                            <Form.Field className={cx(styles.fieldName)}>
                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e, 3)}
                                    value= {_.size(suggest) > 0 ? suggest[3] : ""}
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>5</label>
                            <Form.Field className={cx(styles.fieldName)}>
                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e, 4)}
                                    value= {_.size(suggest) > 0 ? suggest[4] : ""}
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                    <GridRow  className={cx(styles.rowgrid)}>
                        <GridColumn>
                            <label className={cx(styles.questionNumber)}>6</label>
                            <Form.Field className={cx(styles.fieldName)}>
                                <Input
                                    className={cx(styles.inputbox)}
                                    onChange={(e) => handleSuggestionClick(e, 5)}
                                    value= {_.size(suggest) > 0 ? suggest[5] : ""}
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <div className={cx(styles.savingbutton)}>
                <Button className={cx(styles.saving)} onClick={() => handleSavebutton()} >Save</Button>
                </div>
                </Form>
                </Container>
                </Grid.Column>
            </Grid.Row>
        </Grid>
       
    )
}
